import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=3273a3c2"
import script from "./Apps.vue?vue&type=script&lang=ts"
export * from "./Apps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports